import React from 'react';
import DashboardSidebar from '@/components/DashboardSidebar';

/**
 * Fixed left sidebar. Same across all pages — logo, nav items, user profile/logout.
 * Do not modify per page.
 */
export const Sidebar: React.FC = () => {
  return <DashboardSidebar />;
};
